export enum MaintenanceType {
	UNPLANNED = 'unplanned',
	PLANNED = 'planned',
	CARD_PAYMENT = 'cardPayment',
	BLOCKCHAIN = 'blockchain',
}
export const MaintenanceNoticeMessage = {
	[MaintenanceType.UNPLANNED]: {
		title: 'Kris+ customer app is temporarily unavailable',
		message: 'The Kris+ customer app is currently unavailable due to unforeseen technical difficulties. We apologise for any inconvenience caused.',
	},
	[MaintenanceType.PLANNED]: {
		title: 'Kris+ customer app under maintenance',
		message: 'Transactional services will be temporarily unavailable during maintenance. We apologise for any inconvenience caused.',
	},
	[MaintenanceType.CARD_PAYMENT]: {
		title: 'Kris+ customer app is experiencing temporary difficulties',
		message: 'In-app card payment is temporarily unavailable. KrisPay miles can still be used to proceed with payments.',
	},
	[MaintenanceType.BLOCKCHAIN]: {
		title: 'KrisPay miles service temporarily unavailable',
		message: 'Card payments are accepted. Miles earned will be credited once service resumes. For refunds with KrisPay miles, please try again later.',
	},
};
